import React, {createContext, useState} from 'react';

const ShopWidgetHandelContext = createContext({});

export const ShopWidgetProvider = ({children}) => {

  const [showShopWidget, setShowShopWidget] = useState(false);

  return (
    <ShopWidgetHandelContext.Provider value={{showShopWidget, setShowShopWidget}}>
      {children}
    </ShopWidgetHandelContext.Provider>
  );
}

export default ShopWidgetHandelContext;